<template>
  <div class="order-container">
    <Header title="预览"></Header>
    <div class="t-container main">
      <img :src="fileAddress" />
      <p>{{ fileName }}</p>
      <!-- <img src="@/assets/imgs/zhijiandanxq.png" />
      <p>质检单</p>
      -->
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header';
export default {
  name: "ViewContract",
  components: {
    Header
  },
  data() {
    return {
     fileName: "",
     fileAddress: "",
    };
  },
  computed: {
  },
  watch: { 
    
  },
  created() {
    this.fileName = this.$route.query.name;
    this.fileAddress = this.$route.query.address;
  },
  methods: {
 
  },
};
</script>
<style lang="stylus" scoped>
.order-container {
  .t-container {
    text-align: center;
    // padding-top: 40px;
    img {
      width: 100%;
    }
    p {
      font-size: 30px;
      margin-top: 30px;
    }
  }
}
</style>